import { render, staticRenderFns } from "./default-tags.vue?vue&type=template&id=4cc518ff&"
import script from "./default-tags.vue?vue&type=script&lang=js&"
export * from "./default-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports